import React from 'react'

import * as IconList from '../../stories/assets/icons'

export type IconName = keyof typeof IconList
export { IconList }

export type IconsProps = {
  iconName: IconName
  size?: 'small' | 'medium' | 'large' | 'extraLarge'
} & React.SVGProps<SVGSVGElement>

const Icon: React.FC<IconsProps> = (props) => {
  const { iconName, size, ...rest } = props
  const Icon = IconList[iconName]
  const getSize = (): number => {
    if (size === 'small') {
      return 18
    }
    if (size === 'large') {
      return 32
    }
    if (size === 'extraLarge') {
      return 56
    }
    return 24
  }
  return <Icon width={getSize()} height={getSize()} {...rest} />
}

export default Icon
